<template>
	<div class="chatSet">
		<filter-panel :data="groups" @search="filterChange"></filter-panel>
		<el-row type="flex" class="row-bg" justify="end">
			<span style="font-size: 18px">
				<el-tooltip class="item" effect="dark">
					<div slot="content">
						<span>统计维度：服务单(剔除测试客户)</span><br />
						<span>分母：服务期内，外贸云建站，任意站点已上线</span><br />
						<span>分子：分母基础上任意站点已开启插件</span>
					</div>
					<i class="el-icon-question"></i>
				</el-tooltip>
				插件配置率：<span style="font-weight: 700">{{ rate ? rate : '--' }}</span>
			</span>
		</el-row>
		<data-list
			:table-style="{ name: 'mixture' }"
			:data="data"
			:columns="column"
			:loading="loading"
			:page="page"
			:page-size="page.pageSize"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@sort-change="sortChange"
		></data-list>
	</div>
</template>

<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import api from '@/backend/apiConfig/apiConfig';
import listPageCreate from '@/mixins/listPageCreate';
import customerMinxins from '@/mixins/customer';
import beforeRouteEnter from '@/mixins/beforeRouteEnter.js';
import chat from '@/backend/services/account/chat.js';
const page = listPageCreate({
	searchConfig: {
		api: api.chat.getconfig,
		method: 'POST',
	},
	getQuery(data, that) {
		let body = {
			sitePlatform: that.sitePlatform,
			...data,
		};
		that.queryData = body;
		return _.assign({}, body);
	},
});
export default {
	name: 'chatSet',
	props: {},
	components: {
		filterPanel,
	},
	data() {
		const that = this;
		const groups = {
			others: [
				{
					tagName: 'sky-select',
					placeholder: '外贸云建站',
					label: '外贸云建站',
					value: '2',
					prop: 'sitePlatform',
					options: [
						{
							value: '1',
							label: '建站供应商',
						},
						{
							value: '2',
							label: '外贸云建站',
						},
						{
							value: '3',
							label: '客户自有网站',
						},
					],
				},
				{
					tagName: 'sky-select',
					placeholder: '全部配置状态',
					label: '全部配置状态',
					value: '',
					prop: 'configStatus',
					options: [
						{
							value: 0,
							label: '全部配置状态',
						},
						{
							value: 1,
							label: '站点未上线',
						},
						{
							value: 2,
							label: '站点已上线，但主页未创建',
						},
						{
							value: 3,
							label: '站点关联主页ID异常',
						},
						{
							value: 4,
							label: '已配置',
						},
					],
				},
				{
					tagName: 'sky-input',
					placeholder: '输入服务单号',
					label: '服务单号',
					prop: 'serviceId',
					value: '',
					filterable: true,
					remote: false,
				},
				{
					tagName: 'sky-select',
					placeholder: '发布状态',
					label: '发布状态',
					value: '',
					prop: 'releaseStatus',
					options: [
						{
							value: 0,
							label: '未发布',
						},
						{
							value: 1,
							label: '成功',
						},
						{
							value: 2,
							label: '失败',
						},
					],
				},
				{
					tagName: 'sky-select',
					placeholder: '插件启动状态',
					label: '插件启用状态',
					value: '',
					prop: 'fbFlag',
					options: [
						{
							value: 0,
							label: '已关闭',
						},
						{
							value: 1,
							label: '已开启',
						},
					],
				},
			],
		};
		const column = [
			{
				label: '配置状态',
				type: 'mapping',
				mapType: 'text',
				bind: 'configStatus',
				width: 210,
				parentEvent: row => {
					let configStatus = [
						{ label: '站点未上线', value: 1 },
						{ label: '站点已上线，但主页未创建', value: 2 },
						{ label: '站点关联主页ID异常', value: 3 },
						{ label: '已配置', value: 4 },
					];
					if (row) {
						return configStatus.find(item => row == item.value).label;
					} else {
						return '-';
					}
				},
			},
			{
				label: '发布状态',
				type: 'mapping',
				mapType: 'text',
				bind: 'releaseStatus',
				width: 170,
				parentEvent: row => {
					let releaseStatus = [
						{ label: '未发布', value: 0 },
						{ label: '成功', value: 1 },
						{ label: '失败', value: 2 },
					];
					if (row !== null) {
						return releaseStatus.find(item => row == item.value).label;
					} else if (row == null) {
						return '-';
					}
				},
			},
			{
				type: 'custInfo',
				label: '客户名称/服务单号',
				width: 180,
				disabled: true,
				align: 'left',
				text: [
					{
						label: '',
						bind: 'customerName',
						style: {
							'text-align': 'center',
						},
					},
					{
						label: '',
						bind: 'serviceCode',
						style: {
							'text-align': 'center',
						},
					},
				],
			},
			{
				type: 'custInfo',
				label: '语种',
				disabled: true,
				align: 'left',
				text: [
					{
						label: '',
						bind: 'domainName',
						style: {
							'text-align': 'center',
						},
					},
					{
						label: '',
						bind: 'dicname',
						style: {
							'text-align': 'center',
						},
					},
				],
				width: 150,
			},
			{
				label: '上线状态',
				type: 'mapping',
				mapType: 'text',
				bind: 'onlineStatus',
				align: 'left',
				parentEvent: row => {
					let onlineStatus = [
						{ label: '已上线', value: 0 },
						{ label: '未上线', value: 1 },
					];
					if (row) {
						return onlineStatus.find(item => row == item.value).label;
					} else {
						return '已上线';
					}
				},
			},
			{
				label: 'FB主页ID',
				bind: 'tpageId',
				minWidth: 150,
				align: 'center',
			},
			{
				label: '站点关联FB主页ID',
				bind: 'pageId',
				minWidth: 150,
				align: 'center',
			},
			{
				label: '插件启用状态',
				type: 'mapping',
				mapType: 'text',
				bind: 'fbFlag',
				minWidth: 150,
				parentEvent: row => {
					let fbFlag = [
						{ label: '已关闭', value: 0 },
						{ label: '已开启', value: 1 },
					];
					if (row !== null) {
						return fbFlag.find(item => row == item.value).label;
					} else {
						return '-';
					}
				},
			},
			{
				type: 'btnClick',
				label: '操作',
				align: 'center',
				width: 350,
				bind(row) {
					if (row && row.length !== 0) {
						return that.operateBtn;
					} else {
						return [];
					}
				},
			},
		];
		return {
			rate: '',
			groups: groups,
			sitePlatform: 2,
			column: column,
			pageList: [],
			operateBtn: [
				{
					text: '即时聊天配置',
					showButton(row) {
						return true;
						// 注释
						// if (row.tpageId) {
						// 	return that.getPermission(that.$permissionData.socialMediaUpdate.englishName);
						// }
					},
					trigger: function (row) {
						that.configuration(row);
					},
				},
				// {
				// 	text: '推送主页ID',
				// 	showButton(row) {
				// 		if (row.tpageId && row.tpageId !== row.pageId) {
				// 			return that.getPermission(that.$permissionData.socialMediaUpdate.englishName);
				// 		}
				// 	},
				// 	trigger: function (row) {
				// 		that.push(row);
				// 	},
				// },
				{
					text: '关闭插件',
					showButton(row) {
						if (row.fbFlag === 1) {
							return that.getPermission(that.$permissionData.socialMediaUpdate.englishName);
						}
					},
					trigger: function (row) {
						that.openclose(row);
					},
				},
				{
					text: '推送主页ID并开启插件',
					showButton(row) {
						if (row.tpageId && (row.fbFlag === 0 || row.fbFlag === null)) {
							return that.getPermission(that.$permissionData.socialMediaUpdate.englishName);
						}
					},
					trigger: function (row) {
						that.openclose(row);
					},
				},
			],
		};
	},
	mixins: [page, customerMinxins, beforeRouteEnter],
	mounted() {
		this.getSetRate();
	},
	methods: {
		configuration(row) {
			this.$router.push({
				name: 'configPage',
				query: {
					id: row.id,
					serviceSiteId: row.serviceSiteId,
					customerId: row.customerId,
					tpageId: row.tpageId,
					URl: row.url,
					isConfigAutoReply: row.isConfigAutoReply,
				},
			});
		},
		// 开启关闭插件
		async openclose(row) {
			await chat.getplugin({ id: row.id });
			this.query();
		},
		//获取率插件配置率
		async getSetRate() {
			let res = await chat.getSetRate();
			this.rate = res.data;
		},

		// // 推送主页id
		// async push(row) {
		// 	let res = await chat.getpushhome({ id: row.id });
		// 	if (res.data === 'success') {
		// 		alert('推送成功！');
		// 	} else {
		// 		alert('推送失败！');
		// 	}
		// },
	},
};
</script>
<style lang="scss">
.dialogScroll {
	height: 100%;

	& > .el-scrollbar__wrap {
		overflow-x: hidden;
	}
}
</style>
